import { inject, observer } from 'mobx-react'
import React, { useEffect } from 'react'
import { Loader } from 'semantic-ui-react'
import styled from 'styled-components'
import { GlobalFeatureSwitches } from './GlobalFeatureSwitches'
import { SiteFeatureSwitches } from './SiteFeatureSwitches'

export const FeatureSwitchName = ({ name }) => <span>{name.charAt(0).toUpperCase() + name.slice(1).split(/(?=[A-Z])/).join(' ')}</span>

const Container = styled.div`
  position: relative;
  height: 100%;
  & > div {
    padding: 1em 0;
  }
`

export const FeatureSwitches = inject(stores => ({
  featureSwitchesSlice: stores.store.featureSwitchesSlice
}))(observer(({ featureSwitchesSlice }) => {
  const {
    loading,
    fetchAllFeatureSwitches,
    shouldFetchFS,
  } = featureSwitchesSlice
  
  useEffect(() => { 
    if(shouldFetchFS) {
      fetchAllFeatureSwitches()
    }
  }, [])
  
  if(loading) {
    return (
      <Container>
        <Loader active={loading} size="large">Loading...</Loader>
      </Container>
    )
  }

  return (
    <Container>
      <GlobalFeatureSwitches featureSwitchesSlice={featureSwitchesSlice}/>
      <SiteFeatureSwitches featureSwitchesSlice={featureSwitchesSlice}/>
    </Container>
  )
}))
